import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import {
  getFormatedExpirationDate,
  getFormatedNumber,
} from 'cvlib/components/InputCard/utils/format';
import { renderMaxLengthText } from 'utils/renderMaxLengthText';
import './style.scss';

export const Card = ({
  number = '',
  brand = 'default',
  expire = '',
  onClick,
}) => {
  const assets = useSelector(state => state.asset);

  const defaultCard =
    assets?.MDP_MetodosDePago_AgregarMDPTarjeta_Tarjeta_Asset || '';
  const amexCard = assets?.MDP_MetodosDePago_Tarjeta_Asset_Amex || '';
  const masterCard = assets?.MDP_MetodosDePago_Tarjeta_Asset_MasterCard || '';
  const visaCard = assets?.MDP_MetodosDePago_Tarjeta_Asset_Visa || '';

  const defaultLogo =
    assets?.MDP_MetodosDePago_AgregarMDPTarjeta_Tarjeta_AssetTipoTarjeta || '';
  const amexLogo =
    assets?.MDP_MetodosDePago_AgregarMDPTarjeta_Tarjeta_Logo_Amex || '';
  const masterLogo =
    assets?.MDP_MetodosDePago_AgregarMDPTarjeta_Tarjeta_Logo_MasterCard || '';
  const visaLogo =
    assets?.MDP_MetodosDePago_AgregarMDPTarjeta_Tarjeta_Logo_Visa || '';

  const getCardBackground = () => {
    switch (brand?.toLowerCase()) {
      case 'amex':
        return amexCard;
      case 'mastercard':
        return masterCard;
      case 'visa':
        return visaCard;
      default:
        return defaultCard;
    }
  };

  const getCardBrandLogo = () => {
    switch (brand?.toLowerCase()) {
      case 'amex':
        return amexLogo;
      case 'mastercard':
        return masterLogo;
      case 'visa':
        return visaLogo;
      default:
        return defaultLogo;
    }
  };

  const formatedNumber = useMemo(() => getFormatedNumber(number, ''), [
    number,
  ]);
  const formatedEDate = useMemo(() => getFormatedExpirationDate(expire), [
    expire,
  ]);

  return (
    <div
      className={`qrTdcCard ${onClick ? 'qrTdcCard--clickable' : ''}`}
      onClick={onClick}
      style={{ backgroundImage: `url(${getCardBackground()})` }}
    >
      <div className="qrTdcCard__brand">
        {getCardBrandLogo() ? (
          <img
            className="qrTdcCard__brand__logo"
            src={getCardBrandLogo()}
            alt=""
          />
        ) : (
          <span className="qrTdcCard__brand__logo" />
        )}
      </div>

      <div className="qrTdcCard__number">
        {renderMaxLengthText(`${formatedNumber}`, 22)}
      </div>

      <div className="qrTdcCard__footer">
        <span className="qrTdcCard__expiry">{formatedEDate}</span>
      </div>
    </div>
  );
};

export default Card;
